import React from 'react';
import { Box, CssBaseline } from '@mui/material';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import ExpiredUsersDialog from '../ExpiredUsersDialog';

const Layout = () => {

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', bgcolor: '#f5f5f5', minHeight: '100vh' }}>
      <CssBaseline />
      <Navbar />
      <ExpiredUsersDialog />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: { xs: 1, sm: 1, md: 1 },
          width: '98%',
          mx: 'auto',
          overflowX: 'hidden',
          boxSizing: 'border-box',
          bgcolor: '#f5f5f5',
          minHeight: 'calc(100vh - 64px)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          mt: '64px' // Spazio per la navbar fissa in alto
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default Layout;